import React from "react";
import PropTypes from "prop-types";
import { Modal } from "reactstrap";
import keys from "configs/constants";
import InfoDocumentList from "./InfoDocumentList";
import VersionText from "./VersionText";
import "./infoMenu.css";

// Stands in for the version in the translated subtitle, so the sentence keeps
// each language's word order while the version itself is rendered as parts.
const VERSION_SLOT = "\u0000";

const Subtitle = ({ t, parts }) => {
  const [before, after] = t("infoPage.subtitle", {
    version: VERSION_SLOT,
  }).split(VERSION_SLOT);
  return (
    <p className="info-dialog-subtitle">
      {before}
      <VersionText parts={parts} />
      {after}
    </p>
  );
};

/**
 * "Info, privacy, terms and conditions" (AB#49545), opened from the sidebar
 * over the current page so the user keeps their place. Focus is trapped while
 * it is open and returns to the sidebar entry when it closes (reactstrap).
 */
const InfoDialog = ({ isOpen, toggle, t, versionParts = [] }) => (
  <Modal
    isOpen={isOpen}
    toggle={toggle}
    centered
    className="info-dialog"
    contentClassName="info-dialog-content"
    labelledBy="info-dialog-title"
  >
    <div className="info-dialog-header">
      <span className="info-dialog-tile" aria-hidden="true">
        <i className="fas fa-circle-info" />
      </span>
      <div className="info-dialog-heading">
        <h3 id="info-dialog-title" className="info-dialog-title">
          {t("sidebar.infoPrivacyTerms")}
        </h3>
        {versionParts.length > 0 && <Subtitle t={t} parts={versionParts} />}
      </div>
      <button
        type="button"
        className="info-dialog-x"
        aria-label={t("generic.close")}
        onClick={toggle}
      >
        <i className="fas fa-xmark" aria-hidden="true" />
      </button>
    </div>
    <div className="info-dialog-body">
      <InfoDocumentList links={keys.XP_INFO_LINKS} t={t} />
    </div>
    <div className="info-dialog-footer">
      <span>{t("infoPage.newTabHint")}</span>
      <button type="button" className="info-dialog-btn" onClick={toggle}>
        {t("generic.close")}
      </button>
    </div>
  </Modal>
);

InfoDialog.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
  versionParts: PropTypes.arrayOf(PropTypes.string),
};

export default InfoDialog;
